export default function getDate(dateInit) {
  const tempDate = new Date(dateInit);

  let dateDD = tempDate.getDate();
  let dateMM = tempDate.getMonth() + 1;
  let dateYYYY = tempDate.getFullYear();
  if (dateDD < 10) dateDD = "0" + dateDD;
  if (dateMM < 10) dateMM = "0" + dateMM;

  let dateHh = tempDate.getHours();
  let dateMm = tempDate.getMinutes();
  let dateSs = tempDate.getSeconds();
  if (dateHh < 10) dateHh = "0" + dateHh;
  if (dateMm < 10) dateMm = "0" + dateMm;
  if (dateSs < 10) dateSs = "0" + dateSs;

  const time = `T${dateHh}:${dateMm}`;

  const date = `${dateYYYY}-${dateMM}-${dateDD}`;
  const dateTime = `${date}${time}`;
  const dateTimeWithSeconds = `${dateTime}:${dateSs}`;
  const dateTimeWithOffset = `${dateTimeWithSeconds}+02:00`;

  return [
    date,
    dateTime,
    dateTimeWithSeconds,
    dateTimeWithOffset,
    dateYYYY,
    dateMM,
    dateDD,
    dateHh,
    dateMm,
    dateSs,
  ];
}
